import { render, staticRenderFns } from "./fbi.vue?vue&type=template&id=0d2da7f1&scoped=true&"
import script from "./fbi.vue?vue&type=script&lang=js&"
export * from "./fbi.vue?vue&type=script&lang=js&"
import style0 from "./fbi.vue?vue&type=style&index=0&id=0d2da7f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2da7f1",
  null
  
)

export default component.exports